"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The DropOperation constants are used to represent the types of drops that are allowed.
 */
var DropOperation = function DropOperation() {
  _classCallCheck(this, DropOperation);
};

DropOperation.NONE = 0;
DropOperation.MOVE = 1 << 0;
DropOperation.COPY = 1 << 1;
DropOperation.LINK = 1 << 2;
DropOperation.ALL = DropOperation.MOVE | DropOperation.COPY | DropOperation.LINK;
exports.default = DropOperation;